import React, { useCallback, useEffect, useState } from "react";
import { adminGetRudrakshaReports } from "../../api/rudrakshaApi";
import { formatDob } from "../../utils/dob";
import "./AdminConsultations.css"; // shared ac-* admin form/card styles
import "./AdminMobileNumerology.css"; // shared mnA-* list styles

// Lead log: every run of the Rudraksha calculator by a signed-in customer.
export default function AdminRudraksha({ token }) {
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [query, setQuery] = useState("");
  const [data, setData] = useState({ items: [], total: 0, limit: 25 });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    setLoading(true);
    const r = await adminGetRudrakshaReports({ page, q: query }, token);
    if (r.ok && r.success) {
      setData(r.data);
      setError("");
    } else setError(r.message || "Unable to load reports");
    setLoading(false);
  }, [page, query, token]);

  useEffect(() => {
    load();
  }, [load]);

  const pages = Math.max(1, Math.ceil(data.total / data.limit));

  return (
    <div className="ac-wrap">
      <form
        className="mnA-toolbar"
        onSubmit={(e) => {
          e.preventDefault();
          setPage(1);
          setQuery(search.trim());
        }}
      >
        <input className="ac-input" placeholder="Search by name" value={search} onChange={(e) => setSearch(e.target.value)} />
        <button className="ac-btn ac-btn-primary" type="submit">
          Search
        </button>
      </form>
      <p className="mnA-hint">{data.total} calculations. Each row is a signed-in customer who used the Rudraksha calculator.</p>
      {error && <div className="feedback-alert error">{error}</div>}
      {loading ? (
        <p>Loading...</p>
      ) : (
        <div className="mnA-table">
          {data.items.map((r) => (
            <div key={r.id} className="mnA-row">
              <div className="mnA-main">
                <strong>{r.name}</strong>
                <div>
                  DOB {formatDob(r.dob)}
                  {r.timeOfBirth ? ` ${r.timeOfBirth}` : ""}
                  {r.placeOfBirth ? ` - ${r.placeOfBirth}` : ""}
                </div>
                <div>
                  Mulank {r.mulank} / Bhagyank {r.bhagyank}
                  {r.rashi ? ` - ${r.rashi}` : ""}
                  {r.concern ? ` - goal: ${r.concern}` : ""} - suggested {r.picks.split(",").join(", ")} Mukhi
                </div>
                <small>
                  {r.user ? `${r.user.name} - ${r.user.email}${r.user.phone ? ` - ${r.user.phone}` : ""}` : "Unknown user"} -{" "}
                  {new Date(r.createdAt).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" })}
                </small>
              </div>
            </div>
          ))}
          {data.items.length === 0 && <p>No calculations yet.</p>}
        </div>
      )}
      <div className="ac-actions">
        <button className="ac-btn" disabled={page <= 1} onClick={() => setPage((p) => p - 1)}>
          Previous
        </button>
        <span className="mnA-hint">
          Page {page} of {pages}
        </span>
        <button className="ac-btn" disabled={page >= pages} onClick={() => setPage((p) => p + 1)}>
          Next
        </button>
      </div>
    </div>
  );
}
